import styled from "styled-components";
import { Link } from "react-router-dom";

interface IProps {
  isArabic?: boolean;
}
export const Navbar = styled("div")`
overflow: hidden;
background-color: #515358;
width: 100%;
margin: 0 auto;
font-size: 100%;
line-height: 1;
font-family: Arial, Helvetica, sans-serif;
border: 0;
margin: 0;
outline: 0;
padding: 0;
text-align: left;
vertical-align: baseline;
`;

export const Navlinks = styled.div<IProps>`
width:100%;
margin: 0 auto;
max-width: 940px;
background-color: #515358;
text-align: ${(p) => (p.isArabic?"right":"left")};
ul {
  list-style: none;
  display:flex;
  justify-content: space-between;
  padding:0px;
  margin:10px;
  @media screen and (max-width: 960px){
    margin:0 10px;
    }
}
`;
export const SpanList = styled.span<IProps>`
${(p) => (p.isArabic?"padding-right:10px":"padding-left:10px")};
`;

export const Contact = styled("li")`
font-size: 75%;
font-family: Arial, Helvetica, sans-serif;
color: #fff;
@media screen and (max-width: 960px){
border-bottom: 1px solid #828488;
line-height: 36px;
}

`;

export const Email = styled("li")`
font-size: 75%;
font-family: Arial, Helvetica, sans-serif;
color: #fff;
@media screen and (max-width: 960px){
  border-bottom: 1px solid #828488;
  line-height: 36px;
  }
    
`;

export const Twitter = styled("li")`
font-size:75%;
font-family: Arial, Helvetica, sans-serif;
color: #fff;
@media screen and (max-width: 960px){
  line-height: 36px;
  }
`;

export const Anchortag = styled.a<IProps>`
color: #fff;
text-align: center;
font-size: 100%;
font-family: Arial, Helvetica, sans-serif;
text-decoration: none;
cursor: pointer;
padding:${(p) =>(p.isArabic?"0px 8px 0px 0px":"0px 0px 0px 8px")};
`;

export const FooterMap = styled.div<IProps>`
background-color: #3e4045;
width: 100%;
float: left;
font-size: 100%;
line-height: 1;
font-family: Arial, Helvetica, sans-serif;
border: 0;
margin: 0;
outline: 0;
padding: 0;
text-align: ${(p) =>(p.isArabic?"right":"left")};
vertical-align: baseline;

h2 {
  font-size: 112.5%;
  font-weight: bold;
  line-height: 28px;
  //padding: 0 0 16px;
  color: #fff;
  font-family: Arial, Helvetica, sans-serif;
  a {
    color: #fff;
    line-height: 28px;
    font-family: Arial, Helvetica, sans-serif;
}
}

ul {
  padding:  ${(p) =>(p.isArabic?"0 0 0 15px":"0 15px 0 0")};
  font-family: Arial, Helvetica, sans-serif;
}

li {
  font-size: 93.75%;
  line-height: 18px;
  padding: 0 0 9px;
  color: #ccc;
  list-style:none;
  font-family: Arial, Helvetica, sans-serif;
  a {
    color: #ccc;
    line-height: 18px;
    font-family: Arial, Helvetica, sans-serif;
}
}

`;

export const Column = styled.div<IProps>`
float: ${(p) => (p.isArabic?"right":"left")};
padding: 0 15px;
//max-width: 180px;
@media screen and (max-width: 460px){
  border-bottom: 1px solid #828488;
  width: 90%;
  }

`;

export const FooterMapRow = styled("div")`
max-width: 940px;
padding: 10px 0px 0px 0px;
margin: 0 auto;

`;

export const FooterUtility = styled.label<IProps>`

background-color: #3e4045;
width: 100%;
float: left;
font-size: 100%;
line-height: 1;
font-family: Arial, Helvetica, sans-serif;
border: 0;
margin: 0;
outline: 0;
//padding: 57px;
text-align: left;
vertical-align: baseline;
span {
  float: ${(p) => (p.isArabic?"left":"right")};
  @media screen and (min-width: 920px){
    padding: ${(p) => (p.isArabic?"0px 100px 38px 0":"0px 0px 38px 100px")};
    }
    @media screen and (max-width: 920px){
      padding: 0px 0 38px;
    }

  font-size: 68.75%;
  color: #fff;
  line-height: 16px;
}

ul {
  float: ${(p) => (p.isArabic?"right":"left")};
  ${(p) => (p.isArabic?"padding-right: 0px":"padding-left: 10px")};
  //padding: 0px 0px 48px 156px;
  li {
    float: ${(p) => (p.isArabic?"right":"left")};
    padding: 0 18px 0 0;
    font-size: 68.75%;
    color: #fff;
    line-height: 16px;
    list-style: none;
    font-family: Arial, Helvetica, sans-serif;
    border: 0;
    margin: 0;
    outline: 0;
    text-align: left;
    vertical-align: baseline;
    a {
      color: #fff;
      line-height: 16px;
      text-decoration: none;
      cursor: pointer;
  }
  }
}
`;

export const FooterUtilityRow = styled("div")`
border-top: 1px solid #828488;
width: 100%;
margin: 0px auto;
max-width: 940px;
`;
